import { render, staticRenderFns } from "./ConfirmacionTeam.vue?vue&type=template&id=5d7a5164&scoped=true&"
import script from "./ConfirmacionTeam.vue?vue&type=script&lang=js&"
export * from "./ConfirmacionTeam.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmacionTeam.vue?vue&type=style&index=0&id=5d7a5164&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7a5164",
  null
  
)

export default component.exports